import {CySelector} from "../../../../common/cy-classes";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {GeometryHelper} from "../geometry.helper";
import {IOnboardingStep} from "../onboarding-tour.service.interface";

export class OnboardingMainMenuStep implements IOnboardingStep {
    constructor(private _services: IServiceFactoryExtended) {}
    mainText = "ONBOARDING_MENU_STEP_MAIN_TEXT";
    secondaryText = "ONBOARDING_MENU_STEP_SECONDARY_TEXT";
    get targets() {
        if (this._services.mediaQuery.lAndBelow) {
            let targetElement = document.querySelector(CySelector("cy-burger-button"));
            if (!targetElement) {
                return [];
            }
            let rectangle = targetElement.getBoundingClientRect();
            let _target = GeometryHelper.getCircleCircumscribedToTheRectangle(rectangle);
            _target = _target.scaleWith(20);
            return [_target];
        } else {
            let allMenuItems = document.querySelectorAll(CySelector("cy-menu-item"));
            if (allMenuItems.length === 0) {
                return [];
            }
            if (allMenuItems.length <= 2) {
                return [GeometryHelper.getCircleCircumscribedToTheRectangle(allMenuItems[allMenuItems.length - 1].getBoundingClientRect())];
            }
            let secondMenuItem = allMenuItems[1];
            let lastMenuItem = allMenuItems[allMenuItems.length - 1];
            if (this._services.mediaQuery.xlAndBelow || this._services.mediaQuery.lowHeight) {
                if (allMenuItems[2]) {
                    secondMenuItem = allMenuItems[2];
                }
            }
            return [
                GeometryHelper.getCircleCircumscribedToTheRectangle(lastMenuItem.getBoundingClientRect()),
                GeometryHelper.getCircleCircumscribedToTheRectangle(secondMenuItem.getBoundingClientRect())
            ]
        }
    }
}